import { match as es_or_t } from "../../../src/params/es_or_t.ts";
import { match as logsignout } from "../../../src/params/logsignout.ts";
import { match as prop_path } from "../../../src/params/prop_path.ts";

export const matchers = { es_or_t, logsignout, prop_path };